import { AnalyticsService } from '../..'
import { Entity } from '../../../../domain/entity'
import { IEvent } from '../../../../domain/event/event'
import { DOMEvents } from '../../../../utils/dom'
import { IProfile } from '../../../common/profile'
import { IAnalyticsAdapter, IAnalyticsProviderConfig } from '../adapter'
import { MParticle } from '../mparticle'

import { AnalyticsEvent ,IAnalyticsEvent } from '../../../../domain/analytics/event'
import { Button } from '../../../../domain/analytics/providers/mparticle/events/click/button'
import { Consent } from '../../../../domain/analytics/providers/mparticle/events/click/consent'
import { InternalPromo } from '../../../../domain/analytics/providers/mparticle/events/click/internal-promo'
import { Navigation } from '../../../../domain/analytics/providers/mparticle/events/click/navigation'
import { PhotoGallery } from '../../../../domain/analytics/providers/mparticle/events/click/photo-gallery'
import { SocialShare } from '../../../../domain/analytics/providers/mparticle/events/click/social-share'
import { SubscribeNewsletter } from '../../../../domain/analytics/providers/mparticle/events/click/subscribe-newsletter'
import { Widget } from '../../../../domain/analytics/providers/mparticle/events/click/widget'
import { Default } from '../../../../domain/analytics/providers/mparticle/events/default'
import { Video } from '../../../../domain/analytics/providers/mparticle/events/video/video'

import { PageData } from '../../../../domain/analytics/providers/mparticle/events/page-data'

import { ArticleView } from '../../../../domain/analytics/providers/mparticle/events/pageload/article-view'
import { CategoryView } from '../../../../domain/analytics/providers/mparticle/events/pageload/category-view'
import { PageError } from '../../../../domain/analytics/providers/mparticle/events/pageload/page-error'
import { ScreenView } from '../../../../domain/analytics/providers/mparticle/events/pageload/screen-view'
import { Search } from '../../../../domain/analytics/providers/mparticle/events/pageload/search'
import { VideoCenter } from '../../../../domain/analytics/providers/mparticle/events/pageload/video-center'
import { WidgetVideo } from '../../../../domain/analytics/providers/mparticle/events/pageload/widget-video'

import { PageScroll } from '../../../../domain/analytics/providers/mparticle/events/scroll/page-scroll'
import { WidgetInview } from '../../../../domain/analytics/providers/mparticle/events/scroll/widget-inview'

import { Subscription } from '../../../../domain/analytics/providers/mparticle/events/user/subscription'

import { Campaign } from '../../../../domain/analytics/providers/mparticle/events/pageload/campaign'
import { CustomSubscription } from '../../../../domain/analytics/providers/mparticle/events/user/custom-subscription'
import { SetAttributes } from '../../../../domain/analytics/providers/mparticle/events/user/set-attributes'
import { ViafouraEvents } from '../../../../domain/analytics/providers/mparticle/events/viafoura/viafoura-events'
import { VideoEvents } from '../../../../domain/analytics/providers/mparticle/events/video/video-events'

export class EventAdapter extends Entity implements IAnalyticsAdapter<IAnalyticsProviderConfig> {
    public events: IEvent[]
    public signIn: boolean
    public signOut: boolean
    public mparticle = new MParticle()
    private meta: object
    private conf: object

    /**
     * initialize Event Adapter
     *
     */
    public initialize(
        creds: IAnalyticsProviderConfig,
        profile: IProfile,
        events: IAnalyticsEvent[],
        meta: object, conf: object): void {

        this.meta = meta
        this.conf = conf
        // initialize  mparticle Adapter
        this.mparticle.initialize(creds, profile, meta)

        // bind events
        this.bindEvents(events)

        // bind video events
        this.bindVideoEvents()

        // bind viafoura events
        this.bindViafouraEvents()

        // bind subscription event
        this.bindSubscriptionEvents()
    }

    /**
     * Updates event attributes.
     */
    public update(profile: IProfile) {
        SetAttributes(undefined, profile, this.meta)
    }

    /**
     * Get the correct event object for the registered event type
     *
     * @param type
     * @param value
     * @param action
     * @param element
     */
    public getEventByType(type: string, value: string, action: string, element?: Element): IEvent {

        if (action === DOMEvents.click) {
            switch (type.toLowerCase()) {
                case AnalyticsService.clickEventTypes.button:
                    return new Button(type, value, action, element)
                case AnalyticsService.clickEventTypes.consent:
                    return new Consent(type, value, action, element)
                case AnalyticsService.clickEventTypes.widget:
                    return new Widget(type, value, action, element)
                case AnalyticsService.clickEventTypes.navigation:
                    return new Navigation(type, value, action, element)
                case AnalyticsService.clickEventTypes.internalPromotionClick:
                    return new InternalPromo(type, value, action, element)
                case AnalyticsService.clickEventTypes.subscribeNewsletter:
                    return new SubscribeNewsletter(type, value, action, element)
                case AnalyticsService.clickEventTypes.socialShare:
                    return new SocialShare(type, value, action, element)
                case AnalyticsService.clickEventTypes.subscriptionButton:
                case AnalyticsService.clickEventTypes.signinRegModule:
                case AnalyticsService.clickEventTypes.signout:
                case AnalyticsService.clickEventTypes.accountModal:
                    return new Subscription(type, value, action, element)
                case AnalyticsService.clickEventTypes.photoGallery:
                    return new PhotoGallery(type, value, action, element)
                default:
                    return new Default(type, value, action, element)
            }
        } else if (action === AnalyticsService.ACTION_PAGE_LOAD) {
            switch (type.toLowerCase()) {
                case AnalyticsService.pageLoadEventTypes.pageData:
                    return new PageData(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.viewPage:
                    return new ScreenView(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.viewArticle:
                    return new ArticleView(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.widgetVideoLoad:
                    return new WidgetVideo(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.viewCategory:
                    return new CategoryView(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.search:
                    return new Search(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.errorMessageDisplayed:
                    return new PageError(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.campaign:
                    return new Campaign(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.videoCenter:
                    return new VideoCenter(type, value, action, element)
                case AnalyticsService.pageLoadEventTypes.newReg:
                case AnalyticsService.pageLoadEventTypes.regThankScreen:
                case AnalyticsService.pageLoadEventTypes.verificationScreen:
                case AnalyticsService.pageLoadEventTypes.creditCardInfo:
                case AnalyticsService.pageLoadEventTypes.accountConfirmed:
                    return new Subscription(type, value, action, element)
                default:
                    return new Default(type, value, action, element)
            }
        } else if (action === DOMEvents.scroll) {
            switch (type.toLowerCase()) {
                case AnalyticsService.scrollEventTypes.percentPageview:
                    return new PageScroll(type, value, action, element)
                case AnalyticsService.scrollEventTypes.widgetInview:
                    return new WidgetInview(type, value, action, element)
                default:
                    return new Default(type, value, action, element)
            }
        } else if (action === DOMEvents.VIDEO) {
            return new Video(type, value, action, element)
        }
        return new Default(type, value, action, element)
    }

    /**
     * Bind click events to it elements
     * page-load evets are added to this.events and passed
     * over pageOnLoadEvents
     */
    public bindEvents(events: IAnalyticsEvent[]): void {
        for (const event of events) {
            if(event instanceof Default || event instanceof Video) {
                event.setMetaProperties(this.conf)
            } else if (event instanceof AnalyticsEvent) {
                // if the event has been identified as an generic analytics Event specific one, set the meta properties
                // - possibly not the cleanest way to do this
                event.setMetaProperties(this.meta)
            }

            // if the event is a page load event, fire it right away
            if (AnalyticsService.ACTION_PAGE_LOAD === event.action) {
                // handle the event
                event.handle()

            } else if (event.action === DOMEvents.click) {
                // add a click listener for the event
                event.element.addEventListener(DOMEvents.click, event.handle.bind(event))

            } else if (event.action === DOMEvents.scroll) {
                // add a scroll listener
                document.addEventListener(DOMEvents.scroll, event.handle.bind(event))

            } else if (event.action === DOMEvents.VIDEO) {
                // add a scroll listener
                event.element.addEventListener(DOMEvents.VIDEO, event.handleWithDetail.bind(event))
            }
        }
    }

    /**
     * Bind video events to document
     */
    private bindVideoEvents(): void {
        const videoEvents = [
            'video-full-screen',
            'video-started',
            'video-paused',
            'video-ended',
            'video-player-error'
        ]

        videoEvents.forEach((item) => {
            document.addEventListener(
                item,
                (e: any) => {
                    const videoEvent = new VideoEvents(e.type, e.detail, '')
                    videoEvent.setMetaProperties(this.meta)
                    videoEvent.handle()
                },
                false
            )
        })
    }

    /**
     * Bind viafoura events to document
     */
    private bindViafouraEvents(): void {

        const viafouraEvents = [
            'comment-disliked',
            'comment-liked',
            'user-comment',
            'user-updated'
        ]

        viafouraEvents.forEach((item) => {
            document.addEventListener(
                item,
                (e: any) => {
                    const viafouraEvent = new ViafouraEvents(e.type, e.detail, '')
                    viafouraEvent.setMetaProperties(this.meta)
                    viafouraEvent.handle()
                },
                false
            )
        })
    }

    /**
     * Bind subscription events to document
     */
    private bindSubscriptionEvents(): void {

        const events = [
            'new-registration',
            'signin',
            'signout',
            'consent'
        ]

        events.forEach((item) => {
            document.addEventListener(
                item,
                (e: any) => {
                    const customSubscription = new CustomSubscription(e.type, e.detail, '')
                    customSubscription.setMetaProperties(this.meta)
                    customSubscription.handle()
                },
                false
            )
        })
    }
}
